import {OrderListColumns} from "../../components/list/models/OrderListColumns";

export default [
    "account",
    "side",
    "quantity",
    "remaining",
    "code",
    "exchange",
    "price-instruction",
    "limit",
    "lifetime",
    "market",
    "created",
    "status",
    "updated",
    "action-cancel",
    "action-amend",
    "info"
] as OrderListColumns;
